import { Box } from '@hivebrite/design-system/Box';
import { FakeLink } from '@hivebrite/design-system/Link';

import ClampedLinkWorkaround from 'hb-react/shared/components/DesignSystem/ClampedLinkWorkaround';
import useOutboxedFontTheme from 'hb-react/shared/hooks/theme/useOutboxedFontTheme';
import onEnterOrSpacePress from 'hb-react/shared/utils/onEnterOrSpacePress';
import ThemeProvider from 'hb-react/style/ThemeProvider';

import { useTopicsIndexContext } from '../contexts/TopicsIndexContext';
import useTopicsMenuName from '../hooks/useTopicsMenuName';

const TopicsSuperCategoryBreadcrumb = () => {
  const outboxedFontTheme = useOutboxedFontTheme();
  const { selectedSuperCategory, setCategoriesView } = useTopicsIndexContext();
  const { name, totalTopics } = selectedSuperCategory;

  const topicsMenuName = useTopicsMenuName();

  const totalTopicsInfo = totalTopics ? `(${totalTopics})` : '';

  return (
    <ThemeProvider
      theme={outboxedFontTheme.themeName}
      fontBrightness={outboxedFontTheme.fontBrightness}
    >
      <Box
        alignItems="flex-end"
        justifyContent="flex-start"
        font="h2-semibold"
        data-testid="super-categories-breadcrumb"
        flexWrap={{
          s: 'wrap',
          m: 'nowrap',
          l: 'nowrap',
          xl: 'nowrap',
        }}
      >
        <ClampedLinkWorkaround clamp={2}>
          <FakeLink
            font="h2-semibold"
            as="span"
            display="inline"
            onClick={setCategoriesView}
            onKeyPress={onEnterOrSpacePress(setCategoriesView)}
          >
            {topicsMenuName}
          </FakeLink>
          {` > `}
          {`${name} ${totalTopicsInfo}`}
        </ClampedLinkWorkaround>
      </Box>
    </ThemeProvider>
  );
};

export default TopicsSuperCategoryBreadcrumb;
